export default __webpack_public_path__ + "static/media/splash-mobile.a4f24ff7.jpg";